import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useVisibleContainer } from "../hooks/useVisibleContainer";
import { appState } from "../../state";
import { notifyStateChange } from "../../stateBus";
import type { ChatReplyTo } from "../../types";

// Route-effect component for "/chat/:conversationId". Renders nothing -
// ChatThreadScreen.tsx (mounted unconditionally in AppRoot) owns the actual
// rendering into #chatThreadView, reading appState.chatThreadId/
// chatThreadMessages reactively and fetching messages itself.
export function ChatThreadRouteScreen() {
  const { conversationId } = useParams<{ conversationId: string }>();
  // Optional contextual-reply payload (V2 Part E) - currently only
  // GiftViewerDialog's Reply button sets this, via navigate(..., {state}).
  const location = useLocation();
  const replyTo = (location.state as { replyTo?: ChatReplyTo } | null)?.replyTo ?? null;

  useVisibleContainer("chatThreadView");

  useEffect(() => {
    appState.chatThreadId = conversationId ?? null;
    appState.chatThreadMessages = [];
    appState.chatPendingReplyTo = replyTo;
    notifyStateChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId]);

  return null;
}
